import axios from '../../axios'

// 备注相关接口

// 添加备注
export const addRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark/record',
        method: 'post',
        data
    })
}

// 分页查询
export const getRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark/record',
        method: 'get',
        data
    })
}

// 删除备注
export const deleteRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark/record',
        method: 'delete',
        data
    })
}

// 编辑备注
export const editRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark/record',
        method: 'put',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/wish/remark.js